export default __webpack_public_path__ + "static/media/ConveyorMk5.256.7c461e9a.png";